import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

//COMPONENTS
import NavBar from "../../mainStyle/components/navBar/navBar";
import HomeSection from "../../mainStyle/components/homeSections/home";
import MeetTheTeam from "../../mainStyle/components/homeSections/meetTheTeam";
import ServicesAndEvents from "../../mainStyle/components/homeSections/servicesAndEvents";
import Community from "../../mainStyle/components/homeSections/community";
import Links from "../../mainStyle/components/homeSections/links";
import ContactUs from "../../mainStyle/components/homeSections/contactUs";

//STYLES
import * as HomeStyles from "../styles/home";

function Home(props) {
    const [mouseDirection, setMouseDirection] = useState("null");
    const navBarSettings = useSelector((state) => state.navBar);

    useEffect(() => {
        if (props.scroll) {
            document.body.style.overflow = "scroll";
        } else {
            document.body.style.overflow = "hidden";
        }
    }, []);

    return (
        <div id="mainFrame">
            <div style={HomeStyles.navBar}>
                <NavBar />
            </div>
            <div style={{ ...HomeStyles.bodies, top: `${navBarSettings.sitePosition}vh` }}>
                <HomeSection />
            </div>
            <div style={{ ...HomeStyles.bodies, top: `${navBarSettings.sitePosition + 100}vh` }}>
                <MeetTheTeam />
            </div>
            <div style={{ ...HomeStyles.bodies, top: `${navBarSettings.sitePosition + 200}vh` }}>
                <ServicesAndEvents />
            </div>
            <div style={{ ...HomeStyles.bodies, top: `${navBarSettings.sitePosition + 300}vh` }}>
                <Community />
            </div>
            <div style={{ ...HomeStyles.bodies, top: `${navBarSettings.sitePosition + 400}vh` }}>
                <Links />
            </div>
            <div style={{ ...HomeStyles.bodies, top: `${navBarSettings.sitePosition + 500}vh` }}>
                <ContactUs />
            </div>
        </div>
    );
}

export default Home;
